exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-overview .client-overview__info-block {\n  padding: 2.5rem;\n}\n\n.client-overview .hr {\n  white-space: pre;\n}\n\n.client-overview-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n", ""]);

// exports
